/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkTenantTaskChangelog } from '../models/work-tenant-task-changelog';

@Injectable({ providedIn: 'root' })
export class WorkTenantsTaskChangelogsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `taskChangelogsV2ControllerGetAllPending()` */
  static readonly TaskChangelogsV2ControllerGetAllPendingPath = '/v2/tenants/task-changelogs/pending';

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangelogsV2ControllerGetAllPending()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetAllPending$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskChangelog>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskChangelogsV2Service.TaskChangelogsV2ControllerGetAllPendingPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskChangelog>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangelogsV2ControllerGetAllPending$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetAllPending(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskChangelog>> {
    return this.taskChangelogsV2ControllerGetAllPending$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskChangelog>>): Array<WorkTenantTaskChangelog> => r.body)
    );
  }

  /** Path part for operation `taskChangelogsV2ControllerGetAllResolved()` */
  static readonly TaskChangelogsV2ControllerGetAllResolvedPath = '/v2/tenants/task-changelogs/resolved';

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangelogsV2ControllerGetAllResolved()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetAllResolved$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskChangelog>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskChangelogsV2Service.TaskChangelogsV2ControllerGetAllResolvedPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskChangelog>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangelogsV2ControllerGetAllResolved$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetAllResolved(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskChangelog>> {
    return this.taskChangelogsV2ControllerGetAllResolved$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskChangelog>>): Array<WorkTenantTaskChangelog> => r.body)
    );
  }

  /** Path part for operation `taskChangelogsV2ControllerGetAll()` */
  static readonly TaskChangelogsV2ControllerGetAllPath = '/v2/tenants/task-changelogs';

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangelogsV2ControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskChangelog>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskChangelogsV2Service.TaskChangelogsV2ControllerGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskChangelog>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangelogsV2ControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskChangelog>> {
    return this.taskChangelogsV2ControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskChangelog>>): Array<WorkTenantTaskChangelog> => r.body)
    );
  }

  /** Path part for operation `taskChangelogsV2ControllerGetPendingForProject()` */
  static readonly TaskChangelogsV2ControllerGetPendingForProjectPath = '/v2/tenants/task-changelogs/project/{projectId}/pending';

  /**
   * Required permissions: tenants:read, projects:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangelogsV2ControllerGetPendingForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetPendingForProject$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskChangelog>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskChangelogsV2Service.TaskChangelogsV2ControllerGetPendingForProjectPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskChangelog>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangelogsV2ControllerGetPendingForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetPendingForProject(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskChangelog>> {
    return this.taskChangelogsV2ControllerGetPendingForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskChangelog>>): Array<WorkTenantTaskChangelog> => r.body)
    );
  }

  /** Path part for operation `taskChangelogsV2ControllerGetResolvedForProject()` */
  static readonly TaskChangelogsV2ControllerGetResolvedForProjectPath = '/v2/tenants/task-changelogs/project/{projectId}/resolved';

  /**
   * Required permissions: tenants:read, projects:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangelogsV2ControllerGetResolvedForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetResolvedForProject$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskChangelog>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskChangelogsV2Service.TaskChangelogsV2ControllerGetResolvedForProjectPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskChangelog>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangelogsV2ControllerGetResolvedForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetResolvedForProject(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskChangelog>> {
    return this.taskChangelogsV2ControllerGetResolvedForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskChangelog>>): Array<WorkTenantTaskChangelog> => r.body)
    );
  }

  /** Path part for operation `taskChangelogsV2ControllerGetAllForProject()` */
  static readonly TaskChangelogsV2ControllerGetAllForProjectPath = '/v2/tenants/task-changelogs/project/{projectId}';

  /**
   * Required permissions: tenants:read, projects:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangelogsV2ControllerGetAllForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetAllForProject$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskChangelog>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskChangelogsV2Service.TaskChangelogsV2ControllerGetAllForProjectPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskChangelog>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangelogsV2ControllerGetAllForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetAllForProject(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskChangelog>> {
    return this.taskChangelogsV2ControllerGetAllForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskChangelog>>): Array<WorkTenantTaskChangelog> => r.body)
    );
  }

  /** Path part for operation `taskChangelogsV2ControllerGetPendingForTask()` */
  static readonly TaskChangelogsV2ControllerGetPendingForTaskPath = '/v2/tenants/task-changelogs/task/{taskId}/pending';

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangelogsV2ControllerGetPendingForTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetPendingForTask$Response(
    params: {
      taskId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskChangelog>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskChangelogsV2Service.TaskChangelogsV2ControllerGetPendingForTaskPath, 'get');
    if (params) {
      rb.path('taskId', params.taskId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskChangelog>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangelogsV2ControllerGetPendingForTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetPendingForTask(
    params: {
      taskId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskChangelog>> {
    return this.taskChangelogsV2ControllerGetPendingForTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskChangelog>>): Array<WorkTenantTaskChangelog> => r.body)
    );
  }

  /** Path part for operation `taskChangelogsV2ControllerGetResolvedForTask()` */
  static readonly TaskChangelogsV2ControllerGetResolvedForTaskPath = '/v2/tenants/task-changelogs/task/{taskId}/resolved';

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangelogsV2ControllerGetResolvedForTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetResolvedForTask$Response(
    params: {
      taskId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskChangelog>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskChangelogsV2Service.TaskChangelogsV2ControllerGetResolvedForTaskPath, 'get');
    if (params) {
      rb.path('taskId', params.taskId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskChangelog>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangelogsV2ControllerGetResolvedForTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetResolvedForTask(
    params: {
      taskId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskChangelog>> {
    return this.taskChangelogsV2ControllerGetResolvedForTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskChangelog>>): Array<WorkTenantTaskChangelog> => r.body)
    );
  }

  /** Path part for operation `taskChangelogsV2ControllerGetAllForTask()` */
  static readonly TaskChangelogsV2ControllerGetAllForTaskPath = '/v2/tenants/task-changelogs/task/{taskId}';

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangelogsV2ControllerGetAllForTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetAllForTask$Response(
    params: {
      taskId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskChangelog>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskChangelogsV2Service.TaskChangelogsV2ControllerGetAllForTaskPath, 'get');
    if (params) {
      rb.path('taskId', params.taskId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskChangelog>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangelogsV2ControllerGetAllForTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerGetAllForTask(
    params: {
      taskId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskChangelog>> {
    return this.taskChangelogsV2ControllerGetAllForTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskChangelog>>): Array<WorkTenantTaskChangelog> => r.body)
    );
  }

  /** Path part for operation `taskChangelogsV2ControllerAccept()` */
  static readonly TaskChangelogsV2ControllerAcceptPath = '/v2/tenants/task-changelogs/{id}/accept';

  /**
   * Required permissions: tenants:read, tasks:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangelogsV2ControllerAccept()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerAccept$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantTaskChangelog>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskChangelogsV2Service.TaskChangelogsV2ControllerAcceptPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantTaskChangelog>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, tasks:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangelogsV2ControllerAccept$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerAccept(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTenantTaskChangelog> {
    return this.taskChangelogsV2ControllerAccept$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantTaskChangelog>): WorkTenantTaskChangelog => r.body)
    );
  }

  /** Path part for operation `taskChangelogsV2ControllerReject()` */
  static readonly TaskChangelogsV2ControllerRejectPath = '/v2/tenants/task-changelogs/{id}/reject';

  /**
   * Required permissions: tenants:read, tasks:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangelogsV2ControllerReject()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerReject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantTaskChangelog>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskChangelogsV2Service.TaskChangelogsV2ControllerRejectPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantTaskChangelog>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, tasks:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangelogsV2ControllerReject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangelogsV2ControllerReject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTenantTaskChangelog> {
    return this.taskChangelogsV2ControllerReject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantTaskChangelog>): WorkTenantTaskChangelog => r.body)
    );
  }

}
